import styled from 'styled-components';

export const ProductName = styled.span`
  font-weight: 700;
  margin: 0 0 5px 0;
`;
